/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PracticesIcon extends BaseIcon {
  getChildren = () => [ <path d="M9,16V8l7-2.85v7.5ZM1,4,8.45,1,16,4,8.46,7.15ZM8,16,1,12.67V5.12l7,3Z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 16 16'
}
